import {
  ASSET_LAYER_TYPE,
  IMAGE_LAYER_TYPE,
  type LAYER_TYPES,
  LINE_LAYER_TYPE,
  SHAPE_LAYER_TYPE,
  TEXT_LAYER_TYPE,
} from "../constants.ts";
import { designerCanvasStore } from "../stores/designerCanvasStore.ts";
import type { Layer, ShapeType } from "../types.ts";
import { useSelectLayers } from "./useSelectLayers.ts";

type LayerType = (typeof LAYER_TYPES)[number];

export const useCreateLayer = () => {
  const { selectLayers } = useSelectLayers();

  function createLayer({
    layerType,
    assetUuid,
  }: {
    layerType: typeof ASSET_LAYER_TYPE;
    assetUuid?: string;
  }): void;
  function createLayer({
    layerType,
    contentUuid,
  }: {
    layerType: typeof IMAGE_LAYER_TYPE;
    contentUuid?: string;
  }): void;
  function createLayer({
    layerType,
    shapeType,
  }: {
    layerType: typeof SHAPE_LAYER_TYPE;
    shapeType?: ShapeType;
  }): void;
  function createLayer({
    layerType,
  }: {
    layerType: typeof LINE_LAYER_TYPE;
  }): void;
  function createLayer({
    layerType,
  }: {
    layerType: typeof TEXT_LAYER_TYPE;
  }): void;

  function createLayer({
    layerType,
    contentUuid,
    assetUuid,
    shapeType,
  }: {
    layerType: LayerType;
    contentUuid?: string;
    assetUuid?: string;
    shapeType?: ShapeType;
  }): void {
    let newLayer: Layer | undefined;

    switch (layerType) {
      case TEXT_LAYER_TYPE: {
        newLayer = designerCanvasStore.addTextLayer();
        break;
      }
      case IMAGE_LAYER_TYPE: {
        if (!contentUuid) {
          throw new Error("contentUuid is required for image layers");
        }
        newLayer = designerCanvasStore.addImageLayer(contentUuid);
        break;
      }
      case SHAPE_LAYER_TYPE: {
        if (!shapeType) {
          throw new Error("shapeType is required for shape layers");
        }
        newLayer = designerCanvasStore.addShapeLayer(shapeType);
        break;
      }
      case LINE_LAYER_TYPE:
        newLayer = designerCanvasStore.addLineLayer();
        break;
      case ASSET_LAYER_TYPE:
        if (!assetUuid) {
          throw new Error("assetUuid is required for asset layers");
        }
        newLayer = designerCanvasStore.addAssetLayer(assetUuid);
        break;
    }

    if (newLayer) selectLayers([newLayer]);
  }

  return createLayer;
};
